import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('copy_workflow_1'),
    all: defineMessage('all'),
    name: defineMessage('name'),
    email: defineMessage('email'),
    role: defineMessage('role'),
    workflowSteps: defineMessage('workflow_steps'),
    columnsStep: defineMessage('step_choose_columns_to_copy'),
    usersStep: defineMessage('step_choose_users_steps_to_copy_to'),
    copy: defineMessage('copy'),
    next: defineMessage('next'),
    back: defineMessage('back'),
    accountOwner: defineMessage('account_owner'),
    errorMessage: defineMessage('please_ensure_that_both_o_proceed_with_the_copy'),
    errorMessageColumn: defineMessage('select_columns_to_copy_rule'),
};
